import { Alert, Input, Modal, Select, Space, Spin, Switch, Table, Tag, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import cuentaMask from "../../../../Components/cuentaMask";

const { Option } = Select;

/*
  Configuracion del Flujo De Efectivo Diario por empresa.

  Para cada renglon (y para los grupos Clientes / Proveedores / Acreedores) se eligen
  las cuentas contables del catalogo de la empresa que lo alimentan, sus observaciones
  (la columna "Observaciones" del reporte y del Excel) y, en los pasivos, los dias de
  pago para programarlos automaticamente.

  El catalogo se pide UNA vez con selectTodasCuentasContables y lo comparten todos los
  selects: SelectCuentaContableItem hace su propia peticion por instancia y aqui hay
  ~90 renglones.
*/

const DIAS_PAGO = Array.from({ length: 31 }, (_, i) => i + 1);

const BASES = [
  { valor: "cierreMesAnterior", etiqueta: "Saldo al cierre del mes anterior" },
  { valor: "saldoHoy", etiqueta: "Saldo pendiente a hoy" },
  { valor: "ultimoPago", etiqueta: "Monto del último pago" },
];

const NOMBRE_BLOQUE = { ingreso: "Ingresos", egreso: "Egresos", remanente: "Remanente", iva: "IVA" };

const vacio = () => ({ cuentasContablesIds: [], observaciones: "", programacion: null });

const codigoDe = (cuenta) =>
  cuentaMask(
    (cuenta.nivel1 || "") + (cuenta.nivel2 || "") + (cuenta.nivel3 || "") + (cuenta.nivel4 || "") + (cuenta.nivel5 || "")
  );

class ModalConfiguracionFlujo extends Component {
  state = {
    cargando: false,
    guardando: false,
    configurables: [],
    valores: {},
    opcionesCuentas: [],
    etiquetaCuenta: {},
  };

  componentDidUpdate(prev) {
    if (this.props.visible && !prev.visible) this.cargar();
  }

  async cargar() {
    this.setState({ cargando: true });
    const headers = { headers: this.props.headersToken };
    const cuerpo = { empresaId: this.props.empresaId };
    try {
      const [config, cuentas] = await Promise.all([
        axios.post("reportesFinancieros/configuracionFlujoEfectivoDiario", cuerpo, headers),
        this.state.opcionesCuentas.length
          ? Promise.resolve(null)
          : axios.post("cuentascontables/selectTodasCuentasContables", cuerpo, headers),
      ]);
      if (config.data.success !== 2) {
        message.error(config.data.mensaje || "No se pudo cargar la configuración");
        this.setState({ cargando: false });
        return;
      }
      const valores = {};
      (config.data.renglones || []).forEach((r) => {
        valores[r.clave] = {
          cuentasContablesIds: r.cuentasContablesIds || [],
          observaciones: r.observaciones || "",
          programacion: r.programacion || null,
        };
      });
      const cambios = { cargando: false, configurables: config.data.configurables || [], valores };
      if (cuentas && Array.isArray(cuentas.data)) {
        cambios.opcionesCuentas = cuentas.data.map((c) => ({
          value: c._id,
          label: `${codigoDe(c)} - ${c.descripcion}`,
        }));
        cambios.etiquetaCuenta = Object.fromEntries(cambios.opcionesCuentas.map((o) => [o.value, o.label]));
      }
      this.setState(cambios);
    } catch (e) {
      message.error("No se pudo cargar la configuración");
      this.setState({ cargando: false });
    }
  }

  cambiar(clave, campo, valor) {
    this.setState((estado) => ({
      valores: { ...estado.valores, [clave]: { ...(estado.valores[clave] || vacio()), [campo]: valor } },
    }));
  }

  cambiarProgramacion(clave, cambios) {
    const actual = (this.state.valores[clave] || vacio()).programacion || {
      activa: true,
      diasPago: [],
      base: "cierreMesAnterior",
    };
    this.cambiar(clave, "programacion", { ...actual, ...cambios });
  }

  // Cuentas repetidas en dos renglones del mismo bloque: gana el primero, asi que se avisa.
  duplicados() {
    const porCuenta = new Map();
    this.state.configurables.forEach((c) => {
      const ids = ((this.state.valores[c.clave] || {}).cuentasContablesIds || []);
      ids.forEach((id) => {
        const llave = `${c.bloque}|${id}`;
        if (!porCuenta.has(llave)) porCuenta.set(llave, { id, etiquetas: [] });
        porCuenta.get(llave).etiquetas.push(c.etiqueta);
      });
    });
    return [...porCuenta.values()].filter((d) => d.etiquetas.length > 1);
  }

  async guardar() {
    this.setState({ guardando: true });
    try {
      const renglones = this.state.configurables.map((c) => ({ clave: c.clave, ...(this.state.valores[c.clave] || vacio()) }));
      const res = await axios.post(
        "reportesFinancieros/guardarConfiguracionFlujoEfectivoDiario",
        { empresaId: this.props.empresaId, renglones },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        message.success("Configuración guardada");
        this.setState({ guardando: false });
        if (this.props.onGuardado) this.props.onGuardado();
      } else {
        message.warning(res.data.mensaje || "No se pudo guardar la configuración");
        this.setState({ guardando: false });
      }
    } catch (e) {
      message.error("No se pudo guardar la configuración");
      this.setState({ guardando: false });
    }
  }

  columnas() {
    const { opcionesCuentas, valores } = this.state;
    return [
      {
        title: "Renglón",
        key: "renglon",
        width: 300,
        render: (_, c) => (
          <div style={{ paddingLeft: c.tipo === "dato" || c.tipo === "informativo" ? 12 : 0 }}>
            <span style={{ fontWeight: c.tipo === "dato" || c.tipo === "informativo" ? 400 : 600 }}>{c.etiqueta}</span>{" "}
            {c.tipo === "grupo" && <Tag color="cyan">Grupo</Tag>}
            <div style={{ fontSize: 11, color: "#8c8c8c" }}>{NOMBRE_BLOQUE[c.bloque] || ""}</div>
          </div>
        ),
      },
      {
        title: "Cuentas contables",
        key: "cuentas",
        width: 380,
        render: (_, c) => {
          if (c.admiteCuentas) {
            return (
              <Select
                mode="multiple"
                allowClear
                showSearch
                optionFilterProp="label"
                options={opcionesCuentas}
                value={(valores[c.clave] || vacio()).cuentasContablesIds}
                onChange={(ids) => this.cambiar(c.clave, "cuentasContablesIds", ids)}
                placeholder={c.tipo === "grupo" ? "Cuentas de todo el grupo" : "Automático (agrupador SAT)"}
                style={{ width: "100%" }}
                maxTagCount={3}
              />
            );
          }
          if (c.grupo) return <span style={{ fontSize: 12, color: "#8c8c8c" }}>Usa las cuentas de su grupo</span>;
          return null;
        },
      },
      {
        title: "Observaciones",
        key: "observaciones",
        width: 300,
        render: (_, c) =>
          c.admiteObservaciones ? (
            <Input
              value={(valores[c.clave] || vacio()).observaciones}
              placeholder={c.observacion || ""}
              maxLength={300}
              onChange={(e) => this.cambiar(c.clave, "observaciones", e.target.value)}
            />
          ) : null,
      },
      {
        title: "Programación automática",
        key: "programacion",
        width: 420,
        render: (_, c) => {
          if (!c.admiteProgramacion) return null;
          const prog = (valores[c.clave] || vacio()).programacion;
          const activa = !!(prog && prog.activa);
          return (
            <Space wrap>
              <Switch
                size="small"
                checked={activa}
                onChange={(valor) =>
                  valor ? this.cambiarProgramacion(c.clave, { activa: true }) : this.cambiar(c.clave, "programacion", null)
                }
              />
              {activa && (
                <Select
                  mode="multiple"
                  size="small"
                  placeholder="Días de pago"
                  value={prog.diasPago || []}
                  onChange={(dias) => this.cambiarProgramacion(c.clave, { diasPago: dias })}
                  style={{ minWidth: 140 }}
                >
                  {DIAS_PAGO.map((d) => (
                    <Option value={d} key={d}>
                      {d === 31 ? "Último día" : `Día ${d}`}
                    </Option>
                  ))}
                </Select>
              )}
              {activa && (
                <Select
                  size="small"
                  value={prog.base || "cierreMesAnterior"}
                  onChange={(base) => this.cambiarProgramacion(c.clave, { base })}
                  style={{ width: 230 }}
                >
                  {BASES.map((b) => (
                    <Option value={b.valor} key={b.valor}>
                      {b.etiqueta}
                    </Option>
                  ))}
                </Select>
              )}
            </Space>
          );
        },
      },
    ];
  }

  render() {
    const duplicados = this.duplicados();
    const filas = this.state.configurables.filter((c) => c.admiteCuentas || c.admiteObservaciones || c.admiteProgramacion);
    return (
      <Modal
        visible={this.props.visible}
        title="Configurar cuentas del flujo"
        onCancel={this.props.onCancel}
        onOk={() => this.guardar()}
        okText="Guardar"
        cancelText="Cancelar"
        confirmLoading={this.state.guardando}
        width="95%"
        destroyOnClose
      >
        <Spin spinning={this.state.cargando}>
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 10 }}
            message="Cómo se usan las cuentas"
            description={
              <div style={{ fontSize: 12 }}>
                Una cuenta incluye sus subcuentas, y gana la más específica: si Proveedores tiene 201-01 y
                Acreedores 201-01-002, lo de 201-01-002 sale en Acreedores. Las cuentas se buscan sólo entre
                renglones del mismo bloque, así que una cuenta puede ser un ingreso en un renglón y un egreso en
                otro. Un renglón sin cuentas usa la regla automática del agrupador SAT. La programación proyecta,
                en sus días de pago, el monto que sale de las cuentas del renglón.
              </div>
            }
          />
          {duplicados.length > 0 && (
            <Alert
              type="warning"
              showIcon
              style={{ marginBottom: 10 }}
              message="Cuentas repetidas"
              description={
                <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12 }}>
                  {duplicados.map((d) => (
                    <li key={d.id}>
                      {`${this.state.etiquetaCuenta[d.id] || d.id} está en: ${d.etiquetas.join(", ")}. Todo lo de esa cuenta va al primero (${d.etiquetas[0]}).`}
                    </li>
                  ))}
                </ul>
              }
            />
          )}
          <Table
            className="custom-small-table"
            size="small"
            bordered
            columns={this.columnas()}
            dataSource={filas}
            rowKey="clave"
            pagination={false}
            scroll={filas.length ? { x: "max-content", y: "60vh" } : undefined}
            onRow={(c) => ({
              style:
                c.tipo === "grupo"
                  ? { backgroundColor: "#E6F7FF" }
                  : c.tipo === "seccion"
                  ? { backgroundColor: "#F0FEFF" }
                  : c.tipo === "total" || c.tipo === "saldo"
                  ? { backgroundColor: "#FAFAFA" }
                  : {},
            })}
          />
        </Spin>
      </Modal>
    );
  }
}

export default ModalConfiguracionFlujo;
